function DisplayHTMLString(htmlString) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}

function removeHtmlTags(htmlString) {
  return htmlString?.replace(/<[^>]+>/g, "");
}

export { DisplayHTMLString, removeHtmlTags };
